// extracted by mini-css-extract-plugin
module.exports = {"container":"colorItem_container__dGE0F","text":"colorItem_text__27qxU","selectedItem":"colorItem_selectedItem__GS08X"};